export default {
    name: 'layout-cookie',
    components: {},
    data() {
        return {
            show: false,
        };
    },
    mounted() {
        this.show = this.$cookies.get('dgp_cookie_agree') === null;
    },
    methods: {
        closeCookieBlock() {
            this.$cookies.set('dgp_cookie_agree', new Date().toISOString());
            this.show = false;
        },
    },
};
